<section class="modal-header">
    <h4 class="modal-title">Opdatering</h4>
    <button (click)="onDismiss()" type="button" data-bs-theme="dark" class="btn-close" aria-label="Close" tabindex="-1"></button>
</section>

<section class="modal-body">
    <article *ngFor="let note of noter" class="d-flex py-4 note">
        <section class="px-3 pt-4">
            <h4 *ngIf="note.type === 'fix'" class="text-success fa fa-check"></h4>
            <h4 *ngIf="note.type === 'tip'" class="text-warning fa fa-lightbulb"></h4>
            <h4 *ngIf="note.type === 'feature'" class="text-info fa fa-gift"></h4>
        </section>
        <section>
            <small>{{ note.dato | date:'longDate'}}</small>
            <h3>{{ note.overskrift }}</h3>
            <div [innerHTML]="note.html | safeHtml"></div>
        </section>
    </article>
</section>

<section *ngIf="showFooter" class="modal-footer justify-content-between">
    <section class="btn-toolbar">
        <button type="button" class="btn btn-sm btn-outline-primary" (click)="markAllRead()">Marker som læst</button>
    </section>
    <section class="btn-toolbar">
        <button #laterButton type="button" class="btn btn-sm btn-primary ms-2" (click)="onDismiss()">Vis mig senere</button>
    </section>
</section>
